!(function () {
  "use strict";
  customElements.get("banner-image-component") ||
    customElements.define(
      "banner-image-component",
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          ((this.container = this.closest("[data-section-type]")),
            this.handleImageAnimation());
          const e = this.querySelector("[data-banner-title]");
          if (e && !e.classList.contains("text-highlight-wrapper")) {
            const t = e.querySelector("[data-aos]");
            if (!t) return;
            const n = t.closest(".text-reveal__cropper");
            (n?.classList.add("overflow-hidden"),
              window.theme.waitForAnimationEnd(t).then(() => {
                n?.classList.remove("overflow-hidden");
              }));
          }
        }
        handleImageAnimation() {
          const e = this.querySelector("[data-banner-image]").querySelectorAll(
              ".lazy-image",
            ),
            t = this.container.classList.contains("img-in");
          if (e.length && !t) {
            this.container.classList.add("banner--no-cached-images");
            const t = (n) => {
              (requestAnimationFrame(() =>
                this.container.classList.add("banner--img-loaded"),
              ),
                e[0].removeEventListener("transitionend", t));
            };
            e[0].addEventListener("transitionend", t);
          }
        }
      },
    );
})();
